import { LazyLoadImage } from 'react-lazy-load-image-component';
import Skeleton from 'react-loading-skeleton';

import styles from './Icon.module.scss';

export interface IconProps
  extends React.DetailedHTMLProps<
    React.HTMLAttributes<HTMLDivElement>,
    HTMLDivElement
  > {
  testId: string;
  shape?: 'circle' | 'squircle' | null;
  size?: 300 | 400 | 500 | 600 | 700 | 800 | 900;
  image?: string;
  icon?: React.ReactNode;
  alt?: string;
}

export const Icon = ({
  testId,
  shape = null,
  size = 600,
  image,
  icon,
  alt,
  ...props
}: IconProps) => {
  return (
    <div
      {...props}
      className={`${styles.icon} ${props.className || ''}`}
      data-test-id={`${testId}-container`}
      data-shape={shape}
      data-size={size}
    >
      {image && (
        <LazyLoadImage
          data-test-id={`${testId}-image`}
          src={image}
          alt={alt}
          visibleByDefault
          placeholder={
            <Skeleton
              containerClassName={styles.skeletonContainer}
              className={styles.skeleton}
            />
          }
        />
      )}
      {icon && (
        <div className={styles.icon} data-test-id={`${testId}-icon`}>
          {icon}
        </div>
      )}
    </div>
  );
};
